export const URL_API_CURRENT_USER = `/api/current-user`
export const URL_API_USER_STAMPS = `/api/current-user/stamps`
export const URL_API_USER_STAMP = (stampId: string) => `/api/current-user/stamps/${stampId}`
export const URL_IMAGE_USER_STAMP = (uid: string, stampId: string) => `/image/users/${uid}/stamps/${stampId}`

export const URL_API_CURRENT_USER_VISITED_NOTICE = `/api/current-user/visited-notice`

export const URL_API_DOODLE_SHARED_USERS = (doodleId: string) => `/api/doodles/${doodleId}/users`
export const URL_API_DOODLE_SHARED_USER = (doodleId: string, uid: string) => `/api/doodles/${doodleId}/users/${uid}`
export const URL_API_DOODLE_GUEST_LOGIN = (doodleId: string) => `/api/doodles/${doodleId}/login`
export const URL_API_DOODLE_GUEST_LOGOUT = (doodleId: string) => `/api/doodles/${doodleId}/logout`
export const URL_API_DOODLE_MAIL_SHARED_USERS = (doodleId: string) => `/api/doodles/${doodleId}/users/notification`

export const URL_CONNECTION_WS = (doodleId: string) => `/connection/doodles/${doodleId}/ws`
export const URL_CONNECTION_SSE = (doodleId: string) => `/connection/doodles/${doodleId}/sse`
export const URL_CONNECTION_POLLING_COMMANDS = (doodleId: string, connectionId?: string, cursorId?: string) =>
  `/connection/doodles/${doodleId}/polling/commands${connectionId && cursorId ? `?${new URLSearchParams({ connectionId, cursorId })}` : ''}`

export const URL_CONNECTION_STATUS = '/connection/__status'

export const URL_FOLDER = (folderId = '') => `/folders/${folderId}`
export const URL_API_FOLDERS = `/api/folders`
export const URL_API_FOLDER = (folderId = '') => `/api/folders/${folderId}`
export const URL_API_DOODLES_IN_FOLDER = (folderId = '') => (folderId ? `/api/folders/${folderId}/doodles` : `/api/doodles`)

export const URL_API_FOLDER_SHARED_USERS = (folderId: string) => `/api/folders/${folderId}/users`
export const URL_API_FOLDER_SHARED_USER = (folderId: string, uid: string) => `/api/folders/${folderId}/users/${uid}`
export const URL_API_FOLDER_GUEST_LOGIN = (folderId: string) => `/api/folders/${folderId}/login`
export const URL_API_FOLDER_GUEST_LOGOUT = (folderId: string) => `/api/folders/${folderId}/logout`
export const URL_API_FOLDER_CURRENT_USER = (folderId: string) => `/api/folders/${folderId}/current-user`

export const URL_DOODLE = (doodleId: string) => `/doodles/${doodleId}`
export const URL_API_DOODLES = `/api/doodles`
export const URL_API_DOODLE = (doodleId: string) => `/api/doodles/${doodleId}`
export const URL_IMAGE_DRAWING = (doodleId: string) => `/image/doodles/${doodleId}/drawing`
export const URL_IMAGE_THUMBNAIL = (doodleId: string) => `/image/doodles/${doodleId}/thumbnail`

export const URL_API_UPLOADS = `/api/uploads`

export const URL_API_ATTACHMENTS = (doodleId: string) => `/api/doodles/${doodleId}/attachments`
export const URL_IMAGE_ATTACHMENT = (doodleId: string, attachmentId: string) => `/image/doodles/${doodleId}/attachments/${attachmentId}`

export const URL_IMAGE_OVERLAY = (doodleId: string, overlayId: string) => `/image/doodles/${doodleId}/overlays/${overlayId}`

export const URL_QUOTATION_DOODLE = (doodleId: string) => `/doodles/quotation/${doodleId}`
export const URL_QUOTATION_DOODLE_SHAPES_SVG = (doodleId: string) => `/doodles/quotation/${doodleId}/shapes.svg`
export const URL_API_QUOTATION_DOODLE = (doodleId: string) => `/api/doodles/quotation/${doodleId}`
export const URL_API_QUOTATION_IMPORT = '/api/quotation/import'
export const URL_API_QUOTATION_CLONE = (doodleId: string) => `/api/doodles/quotation/${doodleId}/clone`
export const URL_IMAGE_QUOTATION_DRAWING = (doodleId: string) => `/image/doodles/quotation/${doodleId}/drawing`
